import { useRef } from "react";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { handleModalTriggerEvent } from "../../utils/handleModalTriggerEvent";
import { REVIEW_POLICY_OPEN_MODAL_EVENT } from "../reviewPolicyContainer/constants";
import styles from "./ReviewPolicyButton.scss";

const ReviewPolicyButton = () => {
  const { getTranslation } = useRuntimeConstants();
  const buttonRef = useRef();

  const handleClick = () => {
    handleModalTriggerEvent({
      focusOnCloseElement: buttonRef.current,
      eventKey: REVIEW_POLICY_OPEN_MODAL_EVENT,
    });
  };

  return (
    <div className={styles.reviewPolicyButtonContainer}>
      <button
        ref={buttonRef}
        className={styles.reviewPolicyButton}
        onClick={handleClick}
        data-testid="reviewPolicyButton"
      >
        {getTranslation("pdp_ratings_reviews_more_information_cta")}
      </button>
    </div>
  );
};

export default ReviewPolicyButton;
